<script setup lang="ts">
import Button from "@ViewCommonComponents/Button.vue";

const props = defineProps({
    img_tag: String,
    title: String,
    subtitle: String,
    description: String,
    isNeedBtn: {
        type: Boolean,
        default: true
    },
    cardClasses: {
        type: String,
        default: 'max-w-[450px] h-full'
    },
    descriptionClasses: {
        type: String,
        default: 'mb-52px'
    }
});

const cardClasses = [
    'services__item flex flex-col relative border-2',
    'border-custom-brown-100 text-start pb-7 pt-14 px-11',
    'after:absolute after:top-0 after:right-0 after:block',
    'after:w-8 after:h-8 after:border-custom-green-600/50',
    'after:border-l-transparent after:border-b-transparent',
    'after:border-[50px] after:border-solid'
].join(' ');
</script>

<template>
    <div :class="[cardClasses, props.cardClasses]">

        <div class="absolute -top-80px left-0" v-if="props?.img_tag" v-html="props.img_tag"></div>

        <div class="font-medium text-2xl xl:text-2.2xl mb-5">
            {{ props.title }}
        </div>

        <div v-if="props.subtitle" class="font-medium text-lg text-custom-blue-800 my-5">
            {{ props.subtitle }}
        </div>

        <div :class="['text-base xl:text-lg', descriptionClasses]">
            {{ props.description }}
        </div>

        <Button v-if="props.isNeedBtn" as="a" href="#header" classes="inline-flex px-12 self-start py-7 mt-auto">
            {{ __('more_details') }}
        </Button>
    </div>
</template>

<style scoped>

</style>
